import { createSlice } from '@reduxjs/toolkit';

export const productsWithGroupsSlice = createSlice({
	name: 'productsWithGroups',
	initialState: {},
	reducers: {
		addProductsGroup: function (state, action) {
			let ctg = action.payload.category;
			let data = action.payload.data;
			state[ctg] = data;
		},
	},
});

export const { addProductsGroup } = productsWithGroupsSlice.actions;
export default productsWithGroupsSlice.reducer;
